import React from "react";
import { LoanComparisonIcon } from "../../../atoms/icons/loan-comarison";
import { QuoteComparison } from "./QuoteComparison";
import Button from "@mui/material/Button";
import { styled } from "@mui/material";

const QuotesWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  overflowX: "hidden",
});

const QuotesContainer = styled("div")({
  display: "flex",
  gap: "10px",
  overflowX: "auto",
  padding: "0 10px",
});

export const BottomBar = ({ quotes = [], setIsComparisonView }) => {
  const emptySpotsCount = Math.max(0, 5 - quotes.length);

  return (
    <div className="bottom-bar">
      <div className="loan-icon-wrapper">
        <LoanComparisonIcon fill="white" />
        Loan Comparison
      </div>

      <QuotesWrapper>
        <QuotesContainer>
          {quotes.map((quote) => (
            <QuoteComparison key={quote.id} quote={quote} />
          ))}

          {Array.from({ length: emptySpotsCount }).map((_, index) => (
            <div key={`emptySpot-${index}`} className="empty-quote-tag" />
          ))}
        </QuotesContainer>
      </QuotesWrapper>

      <div>
        <Button
          variant="contained"
          disabled={quotes.length < 1}
          sx={{
            borderRadius: "20px",
            backgroundColor: "#5abe89",
            color: "white",
            paddingLeft: "50px",
            paddingRight: "50px",
            textTransform: "none",
            fontWeight: "bold",
            boxShadow: "none",
            minWidth: "100px",
            "&:hover": {
              backgroundColor: "#5abe89",
              color: "white",
              border: "1px solid #9bf9c1",
              boxShadow: "none",
            },
            "&:active": {
              borderColor: "#3a7052",
            },
            "&:focus": {
              outline: "none",
            },
            "&:disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.17)",
              color: "#5abe89",
            },
          }}
          onClick={() => quotes.length >= 1 && setIsComparisonView(true)}
        >
          Compare
        </Button>
      </div>
    </div>
  );
};
